import { AWS_API_URL } from 'global/environment';
import { authorize, deleteRequest } from 'utils/http';

export async function deleteLightningScenarioAPI(scenarioId) {
  return deleteRequest(`${AWS_API_URL}/lighting/scenarios/${scenarioId}`, await authorize());
}
